
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#70767C","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 5.038A5.03 5.03 0 015.038 0h7.924A5.03 5.03 0 0118 5.038v7.924A5.03 5.03 0 0112.962 18H5.038A5.03 5.03 0 010 12.962V5.038zm1.63.197v7.53a3.6 3.6 0 003.605 3.606h7.53a3.6 3.6 0 003.606-3.606v-7.53a3.6 3.6 0 00-3.606-3.606h-7.53A3.6 3.6 0 001.63 5.235z"}}),_c('path',{attrs:{"d":"M9 13.578a4.578 4.578 0 110-9.156 4.578 4.578 0 010 9.156zm0-1.63a2.948 2.948 0 100-5.896 2.948 2.948 0 000 5.896z"}}),_c('circle',{attrs:{"cx":"13.733","cy":"4.19","r":"1.086"}})])])
      }
    
      }
    